export interface Props {
  children: JSX.Element;
  condition?: boolean;
  wrapper: (child: JSX.Element) => JSX.Element;
}

export const ConditionalWrapper = ({ children, condition = false, wrapper }: Props): JSX.Element =>
  condition ? wrapper(children) : children;
